module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wildcard-requirement req"
  }, [_c('div', {
    staticClass: "reqinfo"
  }, [_c('div', {
    staticClass: "wildcard-name"
  }, [_vm._v(_vm._s(_vm.req.name))]), _vm._v(" "), _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Credit Hours:\n      "), (_vm.req.minimum_credits === _vm.req.maximum_credits) ? [_vm._v("\n        " + _vm._s(_vm.req.minimum_credits) + "\n      ")] : [_vm._v("\n        " + _vm._s(_vm.req.minimum_credits) + " - " + _vm._s(_vm.req.maximum_credits) + "\n      ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-834f4056","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wild_card_requirement.vue
// module id = 1135
// module chunks = 1